import { Component, OnInit, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { CategorieService } from '../../../../services/categorie-unite-marque/categorie.service';
import { Categorie } from '../../../../models/categorie';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CroudMarqueCategoryComponent } from '../croud-marque-category/croud-marque-category.component';
import { Subscription } from 'rxjs';
import {ParametreService} from '../../main-parametre/parametre.service';

@Component({
    selector: 'app-parametre-categories',
    templateUrl: './parametre-categories.component.html',
    styleUrls: ['./parametre-categories.component.scss']
})
export class ParametreCategoriesComponent implements OnInit, OnDestroy {
    categories: Categorie[] = [];
    idStation: number = 0;
    idUser: number = 0;
    isLoading: boolean = false;
    private addItemSubscription: Subscription;

    constructor(
        private categorieService: CategorieService,
        private toastr: ToastrService,
        private router: Router,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private parametreService: ParametreService
    ) {
        this.addItemSubscription = this.parametreService.addItem$.subscribe(event => {
            if (event.subType === 'catégorie') {
                this.addCategory(event.idStation);
            }
        });
    }

    ngOnInit(): void {
        this.loadUserData();
    }

    ngOnDestroy(): void {
        this.addItemSubscription.unsubscribe();
    }

    loadUserData(): void {
        const user = localStorage.getItem('currentUser');
        if (user) {
            const currentUser = JSON.parse(user);
           // console.log('Current User:', currentUser);
            this.idUser = currentUser?.id || 0;
            if (currentUser?.stations?.length > 0) {
                this.idStation = currentUser.stations[0].id;
               // console.log('User ID:', this.idUser, 'Station ID:', this.idStation);
                this.loadCategories();
            } else {
                this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
                this.router.navigate(['/create-station']);
            }
        } else {
            this.toastr.error('Utilisateur non connecté.', 'Erreur');
            this.router.navigate(['/pages/authentication/login-v2']);
        }
    }

    loadCategories(): void {
        if (this.idUser && this.idStation) {
            this.isLoading = true;
            this.categorieService.getAll(this.idStation, this.idUser).subscribe({
                next: (categories) => {
                    this.categories = [...categories];
                    this.isLoading = false;
                  //  console.log('Categories loaded:', this.categories);
                    if (categories.length === 0) {
                        //this.toastr.info('Aucune catégorie trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                 //   console.error('API Error:', error);
                    this.toastr.error(error.message || 'Erreur lors du chargement des catégories.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }

    addCategory(idStation: number): void {
        this.idStation = idStation || this.idStation;
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'catégorie';
        modalRef.componentInstance.idStation = this.idStation;
        modalRef.componentInstance.isEditMode = false;
        modalRef.componentInstance.existingData = null;
        modalRef.result.then(
            (newCategory: Categorie) => {
                this.ngZone.run(() => {
                    console.log('Received new category in addCategory:', newCategory);
                    console.log('Is newCategory valid?', {
                        hasLibelle: !!newCategory.libelle,
                        hasId: !!newCategory.id,
                        idNonZero: newCategory.id > 0
                    });
                    if (newCategory && newCategory.libelle && newCategory.id > 0) {
                        this.categories = [newCategory, ...this.categories];
                        console.log('Updated categories:', this.categories);
                        //this.toastr.success('Catégorie ajoutée au tableau !', 'Succès');
                        setTimeout(() => {
                            this.cdr.detectChanges();
                            console.log('Change detection triggered');
                        }, 0);
                    } else {
                        console.warn('Invalid category received:', newCategory);
                        this.toastr.warning('Catégorie non ajoutée localement, actualisation de la liste.', 'Avertissement');
                        this.loadCategories();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                    console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de l\'ajout, actualisation de la liste.', 'Erreur');
                        this.loadCategories();
                    }
                });
            }
        ).catch((error) => {
            console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadCategories();
            });
        });
    }

    editCategory(category: Categorie): void {
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'catégorie';
        modalRef.componentInstance.idStation = this.idStation;
        modalRef.componentInstance.existingData = { ...category };
        modalRef.componentInstance.isEditMode = true;
        modalRef.result.then(
            (updatedCategory: Categorie) => {
                this.ngZone.run(() => {
                   // console.log('Received updated category in editCategory:', updatedCategory);
                  /*  console.log('Is updatedCategory valid?', {
                        hasLibelle: !!updatedCategory.libelle,
                        hasId: !!updatedCategory.id,
                        idNonZero: updatedCategory.id > 0
                    });*/
                    if (updatedCategory && updatedCategory.libelle && updatedCategory.id > 0) {
                        this.categories = this.categories.map(cat =>
                            cat.id === updatedCategory.id ? updatedCategory : cat
                        );
                      //  console.log('Updated categories:', this.categories);
                        this.toastr.success('Catégorie mise à jour !', 'Succès');
                        setTimeout(() => {
                            this.cdr.detectChanges();
                         //   console.log('Change detection triggered');
                        }, 0);
                    } else {
                        console.warn('Invalid category received:', updatedCategory);
                        //this.toastr.warning('Catégorie non mise à jour localement, actualisation de la liste.', 'Avertissement');
                        this.loadCategories();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                  //  console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de la mise à jour, actualisation de la liste.', 'Erreur');
                        this.loadCategories();
                    }
                });
            }
        ).catch((error) => {
            console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadCategories();
            });
        });
    }
}
